export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    GET_ALL_REQUEST: 'USERS_GET_ALL_REQUEST',
    GET_ALL_SUCCESS: 'USERS_GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'USERS_GET_ALL_FAILURE',

    UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'USER_UPDATE_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',

    LINK_EMAIL_REQUEST: 'LINK_EMAIL_REQUEST',
    LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS: 'LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS',
    LINK_EMAIL_USER_EXISTS: 'LINK_EMAIL_USER_EXISTS',
    LINK_EMAIL_SUCCESS: 'LINK_EMAIL_SUCCESS',
    
    LINK_EMAIL_FAILURE: 'LINK_EMAIL_FAILURE',
    
    
    
    GET_CONNECTION_NAMES_REQUEST: 'GET_CONNECTION_NAMES_REQUEST',
    GET_CONNECTION_NAMES_SUCCESS: 'GET_CONNECTION_NAMES_SUCCESS',
    GET_CONNECTION_NAMES_FAILURE: 'GET_CONNECTION_NAMES_FAILURE', 


};


// WEBPACK FOOTER //
// ./src/constants/user.constants.js